import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signin from "../views/Signin";
import Users from "../views/Users";
import Services from "../views/Services";
import Service from "../views/Service";
import User from "../views/User";
import Forgot from "../views/Forgot";
import Reset from "../views/Reset";
import ConfirmServices from "../views/ConfirmServices";
import EmailVerified from "../views/EmailVerified";
import ApiKeys from "@/views/ApiKeys";
import Reports from "../views/Reports";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
    {
      path: '/signin',
      name: 'Sign in',
      component: Signin,
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot,
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset,
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
    },
    {
      path: '/users/:id',
      name: 'User',
      component: User,
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
    },
    {
      path: '/services/:id',
      name: 'Service',
      component: Service,
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/confirm',
      name: 'Confirm Services',
      component: ConfirmServices,
    },
    {
      path: '/account/verify',
      name: 'Verify',
      component: EmailVerified,
    },
    {
      path: '/apikeys',
      name: 'API Keys',
      component: ApiKeys,
    },
    // otherwise redirect to home
    { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/signin', "/signout", "/forgot", "/reset", "/account/verify"];
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !localStorage.getItem("account") && !localStorage.getItem("token")) {
    return next('/signin');
  }

  next();
})

export default router
